import React from "react";
import { Phone, Mail, MapPin, Globe } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer id="kontakt" className="bg-[#2A332C] text-[#FDFBF7] py-24 sm:py-32" data-testid="footer-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14">
          <div className="lg:col-span-7">
            <p className="eyebrow mb-6" style={{ color: "#D9A889" }}>Kontakt</p>
            <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[1.02] mb-10">
              Lass uns <span className="font-display-italic">sprechen</span>.
            </h2>
            <p className="text-[#FDFBF7]/75 text-lg max-w-xl leading-relaxed">
              Ich bin per Telefon oder Mail erreichbar. Melde dich gerne – auch für eine erste unverbindliche Frage.
            </p>
          </div>

          <div className="lg:col-span-5 space-y-6">
            <a
              href="tel:0792747271"
              className="flex items-start gap-4 group"
              data-testid="footer-phone"
            >
              <Phone className="w-5 h-5 mt-1 flex-shrink-0 text-[#D9A889]" />
              <div>
                <p className="eyebrow mb-1" style={{ color: "#D9A889" }}>Telefon</p>
                <p className="font-display text-2xl group-hover:text-[#D9A889] transition-colors">
                  079 274 72 71
                </p>
              </div>
            </a>
            <a
              href="mailto:michele.galliker@bluewin.ch"
              className="flex items-start gap-4 group"
              data-testid="footer-email"
            >
              <Mail className="w-5 h-5 mt-1 flex-shrink-0 text-[#D9A889]" />
              <div>
                <p className="eyebrow mb-1" style={{ color: "#D9A889" }}>E-Mail</p>
                <p className="font-display text-2xl group-hover:text-[#D9A889] transition-colors break-all">
                  michele.galliker@bluewin.ch
                </p>
              </div>
            </a>
            <div className="flex items-start gap-4" data-testid="footer-address">
              <MapPin className="w-5 h-5 mt-1 flex-shrink-0 text-[#D9A889]" />
              <div>
                <p className="eyebrow mb-1" style={{ color: "#D9A889" }}>Adresse</p>
                <p className="font-display text-2xl">Oberdorf 1<br />6206 Neuenkirch</p>
              </div>
            </div>
            <a
              href="https://wochenbettbetreuung.ch"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-start gap-4 group"
              data-testid="footer-portal-link"
            >
              <Globe className="w-5 h-5 mt-1 flex-shrink-0 text-[#D9A889]" />
              <div>
                <p className="eyebrow mb-1" style={{ color: "#D9A889" }}>Auch zu finden auf</p>
                <p className="font-display text-2xl group-hover:text-[#D9A889] transition-colors break-all">
                  wochenbettbetreuung.ch
                </p>
              </div>
            </a>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-[#FDFBF7]/15 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-[#FDFBF7]/60">
          <p>© {new Date().getFullYear()} Michele Galliker · Wochenbettbetreuung</p>
          <Link to="/admin/login" className="hover:text-[#FDFBF7] transition-colors" data-testid="footer-admin-link">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
